<template>
  <div class="tab-wrap">
    <van-tabs
      title-active-color="#FFFFFF"
      title-inactive-color="#FFDABD"
      animated
      type="line"
      color="#FFFFFF"
      line-width="20"
      line-height="4"
      :active="activeIndex"
      @change="typeChange">
      <van-tab title="主页" name=0 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="网站推广" name=1 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="我的会员" name=2 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="推广订单" name=3 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="会员排名" name=10 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="收益明细" v-if="!isBasic" name=4 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="佣金提现审核" v-if="!isBasic" name=5 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="公众号授权" name=6 :disabled="tabIsDisabled"></van-tab>
      <van-tab title="激活续费" name=7></van-tab>
      <van-tab title="提现记录" name=8 :disabled="tabIsDisabled"></van-tab>
      <van-tab :title="isBasic ? '设置' : '基础设置'" name=9 :disabled="tabIsDisabled"></van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getToken, getIsBasic, getHasPackage } from '@/utils/auth'
export default {
  name: 'OfficialTab',
  data(){
    return{
      //activeIndex: 0,
      currentTab: '',
      isBasic: getIsBasic() === 'true' ? true : false,
      tabIsDisabled: getHasPackage() === 'true' ? false : true
    }
  },
  computed:{
    activeIndex: function () {
      return this.$store.getters.tabOfficialActiveIndex
    },
  },
  watch: {
    $route: function (to, from) {
      var path = to.path
      this.getCurIndex(path)
    }
  },
  mounted: function () {
    var path = this.$route.path
    this.getCurIndex(path)
  },
  methods:{
    getCurIndex(path){
      var index = 0;
      switch (path) {
        case '/h5/official/statistics':
          index = 0
          break;
        case '/h5/official/invite':
          index = 1
          break;
        case '/h5/official/member':
          index = 2
          break;
        case '/h5/official/order':
          index = 3
          break;
        case '/h5/official/sort':
          index = 10
          break;
        case '/h5/official/mingxi':
          index = 4
          break;
        case '/h5/official/commission':
          index = 5
          break;
        case '/h5/official/authorization':
          index = 6
          break;
        case '/h5/official/dialog':
          index = 7
          break;
        case '/h5/official/withdraw':
          index = 8
          break;
        case '/h5/official/set':
          index = 9
          break;
        default:
          index = 0
      }
      index = index.toString()
      this.$store.dispatch('h_nav/changeOfficialActiveIndex',index)
      if(!this.$pc){
        this.typeChange(index)
      } else{
        this.hasPackage = (getHasPackage() === 'true')
        if (this.hasPackage === false  && index !== '7') {
          this.$store.dispatch('h_nav/changeOfficialActiveIndex', '7')
          this.$router.push('/h5/official/dialog')
        }
      }
    },
    typeChange(index){
      if(getHasPackage() === 'true'){
        this.tabIsDisabled = false
      } else {
        this.tabIsDisabled = true
      }
      var isNext = true
      var token = getToken()
      if (token === undefined || token === '') {
        isNext = false
        // 弹窗提示
        this.$dialog.alert({
          title: '提示',
          message: '您还未登录，请先登录！',
          theme: 'round-button',
        }).then(() => {
          // on close
          this.$router.push('/h5/login')
        })
      }

      if (isNext == false) {
        return
      }

      var url;
      switch (index) {
        case '0':
          url = '/h5/official/statistics'
          break;
        case '1':
          url = '/h5/official/invite'
          break;
        case '2':
          url = '/h5/official/member'
          break;
        case '3':
          url = '/h5/official/order'
          break;
        case '10':
          url = '/h5/official/sort'
          break;
        case '4':
          url = '/h5/official/mingxi'
          break;
        case '5':
          url = '/h5/official/commission'
          break;
        case '6':
          url = '/h5/official/authorization'
          break;
        case '7':
          url = '/h5/official/dialog'
          break;
        case '8':
          url = '/h5/official/withdraw'
          break;
        case '9':
          url = '/h5/official/set'
          break;
        default:
          url = '/h5/official/statistics'
          break;
      }

      this.hasPackage = (getHasPackage() === 'true')
      if (this.hasPackage === false) {
        var that = this;
        //未开通套餐时，点击任何菜单都是跳转到激活续费页面
        // 弹窗提示
        // Modal.warning({
        //   title: '提示',
        //   content: '您还未购买套餐类型！请先购买',
        //   onOk: function() {
        //     that.$router.push('/pc/official/dialog').catch(err => {
        //       err
        //     })
        //     that.$store.dispatch('nav/changeOfficialAccountActiveIndex', 5)
        //   }
        // })
        that.$store.dispatch('h_nav/changeOfficialActiveIndex', '7')
        that.$router.push('/h5/official/dialog')
        return;
      } else {
        this.$store.dispatch('h_nav/changeOfficialActiveIndex',index)
        this.$router.push(url).catch(err => { err })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.tab-wrap{
  width: calc(100%);
  background: #FF8622;
  box-shadow: 0 1px 0 0 #E8E8E8;
  top: 44px;
  z-index: 1;
  font-family: Alibaba-PuHuiTi-R;
}
/deep/.van-tabs{
  background-color:#FF8622;
}
/deep/.van-tabs__wrap{
  width: 100%;
  height: 34px;
  line-height: 34px;
  background: #FF8622;
}
/deep/.van-tab--active{
  font-size: 15px;
}
/deep/.van-tabs__nav{
  background-color:#FF8622;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/OfficialTab.vue